import { PaymentLinkAlreadyPaid } from '../components/PaymentLinkAlreadyPaid';
import { PaymentLinkExpired } from '../components/PaymentLinkExpired';
import { ModalPaymentLinkActivating } from '../components/Modals/ModalPaymentLinkActivating';
import { ModalPaymentLinkFailed } from '../components/Modals/ModalPaymentLinkFailed';
import { ModalPaymentLinkSubmitted } from '../components/Modals/ModalPaymentLinkSubmitted';
import { ModalPaymentLinkPix } from './_modals/ModalPaymentLinkPix';
import { ModalPaymentLinkBoleto } from './_modals/ModalPaymentLinkBoleto';

import { BillingAddressSection } from './_components/BillingAddressSection';
import { ErrorToast } from './_components/ErrorToast';
import { IdentificationSection } from './_components/IdentificationSection';
import { PageHeader } from './_components/PageHeader';
import { PaymentMethodSection } from './_components/PaymentMethodSection';
import { PurchaseSummary } from './_components/PurchaseSummary';
import { SubmitPaymentSection } from './_components/SubmitPaymentSection';

import { usePaymentLinkBootstrap } from './paymentLink.bootstrap.hook';

import {
  GlobalStyles,
  PaymentColumn,
  PaymentContainer,
  PaymentPage,
  SectionHeader,
} from './styles';

export const PaymentLinkV2 = () => {
  const {
    form,
    paymentState,
    isValidating,
    isExpired,
    isAlreadyPaid,
    termsAccepted,
    setTermsAccepted,
    selectPaymentMethod,
    isLoading,
    paymentSubmitted,
    paymentFailed,
    oneTimePaymentResult,
    dismissFailure,
    finishOneTimePayment,
    errorMessage,
    dismissError,
    accessPlatform,
  } = usePaymentLinkBootstrap();

  if (isValidating) return <></>;

  if (isExpired) return <PaymentLinkExpired />;

  if (isAlreadyPaid) return <PaymentLinkAlreadyPaid />;

  return (
    <>
      <GlobalStyles />

      <PaymentPage>
        <PageHeader />

        <PaymentContainer>
          <SectionHeader>
            <h1>Detalhes do pagamento</h1>
            <p>Insira as informações solicitadas para concluir o pagamento.</p>
          </SectionHeader>

          <PaymentColumn>
            <IdentificationSection form={form} />

            <PaymentMethodSection
              form={form}
              paymentMethodSelected={form.values.paymentMethodSelected}
              allowedPaymentMethods={paymentState.allowedPaymentMethods}
              onSelectPaymentMethod={selectPaymentMethod}
            />

            <BillingAddressSection form={form} />
          </PaymentColumn>

          <PurchaseSummary paymentState={paymentState}>
            <SubmitPaymentSection
              termsAccepted={termsAccepted}
              onTermsAcceptedChange={setTermsAccepted}
              isLoading={isLoading}
              onSubmit={form.handleSubmit}
            />
          </PurchaseSummary>
        </PaymentContainer>
      </PaymentPage>

      <ModalPaymentLinkFailed open={paymentFailed} onTryAgain={dismissFailure} />

      <ModalPaymentLinkSubmitted
        open={paymentSubmitted}
        title="Pagamento confirmado"
        description="Seu pagamento foi processado com sucesso e sua assinatura está ativa. Aproveite os recursos da Jusfy!"
        actionText="Acessar plataforma"
        onAccessPlatform={accessPlatform}
      />

      <ModalPaymentLinkActivating open={isLoading} />

      <ModalPaymentLinkPix
        open={oneTimePaymentResult?.method === 'pix'}
        data={oneTimePaymentResult?.data}
        onClose={finishOneTimePayment}
      />

      <ModalPaymentLinkBoleto
        open={oneTimePaymentResult?.method === 'boleto'}
        data={oneTimePaymentResult?.data}
        onClose={finishOneTimePayment}
      />

      {errorMessage && (
        <ErrorToast message={errorMessage} onClose={dismissError} />
      )}
    </>
  );
};
